import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { SensorDefaultConfiguration } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseQueryOptions<unknown, Error, SensorDefaultConfiguration>,
    'queryKey' | 'queryFn'
  >;
}

export const useSensorDefaultConfigurationRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, SensorDefaultConfiguration>(
    [Entities.SensorConfiguration, 'default_configuration'],
    async () => {
      const { data } = await api.v1AdminSensorsDefaultConfigurationGet()
      return data
    },
    {
      ...options,
    },
  )
}
